import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export default function OneUserProgramsComponent({
  selectedOneUser
}: any) {
  return (
    <>
      {/* Basic Info with Community Table */}
      <AccordionContainer
        expandedPanel="userInfo"
        headerTitle="Programs Info"
        child={
          <div className="grid gap-4">
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-300 rounded-lg">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="px-4 py-2 border">#</th>
                    <th className="px-4 py-2 border text-left">Program Name</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedOneUser?.Programs?.length > 0 ? (
                    selectedOneUser.Programs.map((Program: any, index: number) => (
                      <tr key={Program.Id} className="hover:bg-gray-100">
                        <td className="px-4 py-2 border text-center">{index + 1}</td>
                        <td className="px-4 py-2 border">{Program.Name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2} className="px-4 py-2 border text-center text-gray-500">
                        No communities available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        }
      />

    
    </>
  );
}
